import React from 'react';
import { useSelector } from 'react-redux';
import * as Icons from '@material-ui/icons';
import cx from 'classnames';
import Panels from './PanelsForm';
import data from './content.json';

const SignForm = () => {
    const { tab } = useSelector((state) => state.sign);
    const signFormClasses = cx('sign__form', {
        'sign__form--white': tab === 'newPassword',
    });

    return (
        <section className="sign">
            <div className="sign__wrapper">
                <div className="sign__content" style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/assets/garneczki-sign.png)`
                }}>
                    <div className="sign__content--header">Oto dlaczego warto założyć konto</div>
                    <div className="sign__content--logo">
                        <img src={process.env.PUBLIC_URL + '/logo.png'} className="" alt="logo" />
                    </div>
                    <ul className="sign__content--list">
                        {data.map((item, key) => {
                            const ContentIcon = Icons[item.icon];
                            return (
                                <li key={key} className="sign__content--item">
                                    <ContentIcon />
                                    {item.content}
                                </li>
                            );
                        })}
                    </ul>
                </div>
                <div className={signFormClasses}>
                    <Panels />
                </div>
            </div>
        </section>
    );
};

export default SignForm;
